import * as React from 'react';

type TableProps = React.DetailedHTMLProps<React.TableHTMLAttributes<HTMLTableElement>, HTMLTableElement>;

export const Table: React.FC<TableProps> = ({ children, ...props }) => {
	const attrs = props || {} as TableProps;
	const classList = ['table'];
	if (attrs.className) {
		classList.push(attrs.className);
	}
	return <table {...attrs} className={classList.join(' ')} >{children}</table>;
};
